module.exports = __webpack_public_path__ + "13bc1bcbb0047a66e2d8c08ac99231fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/history/2.jpg
// module id = 315
// module chunks = 0